import BaseSetup from '@/components/BaseSetup';
import TagListItemEntity from '@/entity/TagListItemEntity';
import useTagService from '@/services/tag/TagService';
import { Reactive } from '@/utils/decorators';
import { } from 'vue';

export type SharedTagSelectEmits = {
	(e: 'update:modelValue', val: number | number[] | undefined): void
};

export type SharedTagSelectProps = {
	multiple?: boolean
	modelValue?: number | number[]
};

export default class SharedTagSelectSetup extends BaseSetup {

	static readonly defaultProps = { multiple: false };

	@Reactive private readonly state = {
		dataLoaded: false,
		options: [] as TagListItemEntity[],
	};

	get dataLoaded () { return this.state.dataLoaded }
	get options () { return this.state.options }

	get selectedTagIds () { return this.props.modelValue }
	set selectedTagIds (val) { this.emits('update:modelValue', val) }

	constructor (
		private props: SharedTagSelectProps,
		private emits: SharedTagSelectEmits,
	) {
		super();
	}

	async onBeforeMountAsync () {
		this.state.options = TagListItemEntity.map(await useTagService().orderedListAsync());
		this.state.dataLoaded = true;
	}

	getTagById (id: number) {
		return this.state.options.findByKey(id);
	}

}
